<!-- Botón de guía: solo desktop -->
<p-button class="hidden md:inline-flex font-bold text-base" label="¿Cómo funciona esto?" icon="pi pi-info-circle" iconPos="left" [raised]="true" [rounded]="true" severity="info" (onClick)="iniciarGuia()" />

<div class="max-w-full overflow-x-auto p-4 space-y-6">
    <!-- Tabla de causas potenciales -->
    <p-table [value]="matrizDatos" [tableStyle]="{ 'min-width': '90rem' }" class="text-sm" id="step1">
        <ng-template pTemplate="header">
            <tr class="text-center text-gray-700 dark:text-gray-200 text-sm">
                <th colspan="8" class="border-y py-2"></th>
                <th colspan="4" class="border-y py-2 text-center">Probabilidad de Ocurrencia</th>
            </tr>

            <tr class="text-center text-gray-700 text-sm">
                <th colspan="8" class="border-y py-2 text-center">Causas Potenciales</th>
                <th class="border-y py-2 text-center">1</th>
                <th class="border-y py-2 text-center">2</th>
                <th class="border-y py-2 text-center">3</th>
                <th class="border-y py-2 text-center">4</th>
            </tr>

            <tr id="step2">
                <th class="bg-green-900 text-white text-center rounded-tl-lg"></th>
                <th class="bg-green-900 text-white text-center">Nivel</th>
                <th class="bg-green-900 text-white text-center">Lesión Enfermedad</th>
                <th class="bg-green-900 text-white text-center">Vehicular</th>
                <th class="bg-green-900 text-white text-center">Medio Ambiente</th>
                <th class="bg-green-900 text-white text-center">Propiedad/Procesos</th>
                <th class="bg-green-900 text-white text-center">Reputación</th>
                <th class="bg-green-900 text-white text-center">Seguridad Física / Delitos</th>
                <th class="bg-green-900 text-white text-center">Remoto</th>
                <th class="bg-green-900 text-white text-center">Improbable</th>
                <th class="bg-green-900 text-white text-center">Probable</th>
                <th class="bg-green-900 text-white text-center rounded-tr-lg">Frecuente</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-fila>
            <tr id="step3">
                <td class="font-semibold">{{ fila.nivel }}</td>
                <td class="font-semibold">{{ fila.nivel_text }}</td>
                <td>{{ fila.lesion }}</td>
                <td>
                    <div class="truncate max-w-[100px] text-gray-700 dark:text-gray-200 cursor-pointer" pTooltip="{{ fila.vehicular }}" tooltipEvent="focus" tooltipPosition="top" tabindex="0">
                        {{ fila.vehicular }}
                    </div>
                </td>
                <td>
                    <div class="truncate max-w-[100px] text-gray-700 dark:text-gray-200 cursor-pointer" pTooltip="{{ fila.medioAmbiente }}" tooltipEvent="focus" tooltipPosition="top" tabindex="0">
                        {{ fila.medioAmbiente }}
                    </div>
                </td>
                <td>
                    <div class="truncate max-w-[100px] text-gray-700 dark:text-gray-200 cursor-pointer" pTooltip="{{ fila.propiedadProcesos }}" tooltipEvent="focus" tooltipPosition="top" tabindex="0">
                        {{ fila.propiedadProcesos }}
                    </div>
                </td>
                <td>
                    <div class="truncate max-w-[100px] text-gray-700 dark:text-gray-200 cursor-pointer" pTooltip="{{ fila.reputacion }}" tooltipEvent="focus" tooltipPosition="top" tabindex="0">
                        {{ fila.reputacion }}
                    </div>
                </td>
                <td>
                    <div class="truncate max-w-[100px] text-gray-700 dark:text-gray-200 cursor-pointer" pTooltip="{{ fila.seguridadFisica }}" tooltipEvent="focus" tooltipPosition="top" tabindex="0">
                        {{ fila.seguridadFisica }}
                    </div>
                </td>

                @for (prob of [1, 2, 3, 4]; track prob) {
                    <td class="text-center" id="step4">
                        <div class="flex items-center justify-center h-full w-full p-2 rounded-md cursor-pointer select-none transition-all" (click)="seleccionar(fila.nivel, prob)">
                            <div
                                class="w-8 h-8 rounded-md flex items-center justify-center transition-all duration-200"
                                [ngClass]="[
                                    fila.valorRiesgo[prob] === 1
                                        ? estaSeleccionado(fila.nivel, prob)
                                            ? 'bg-green-400 dark:bg-green-500'
                                            : 'bg-green-200 dark:bg-green-700'
                                        : fila.valorRiesgo[prob] === 2
                                          ? estaSeleccionado(fila.nivel, prob)
                                              ? 'bg-yellow-400 dark:bg-yellow-500'
                                              : 'bg-yellow-200 dark:bg-yellow-700'
                                          : fila.valorRiesgo[prob] === 3
                                            ? estaSeleccionado(fila.nivel, prob)
                                                ? 'bg-orange-400 dark:bg-orange-500'
                                                : 'bg-orange-200 dark:bg-orange-700'
                                            : estaSeleccionado(fila.nivel, prob)
                                              ? 'bg-red-400 dark:bg-red-500'
                                              : 'bg-red-200 dark:bg-red-700'
                                ]"
                            >
                                @if (estaSeleccionado(fila.nivel, prob)) {
                                    <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                }
                            </div>
                        </div>
                    </td>
                }
            </tr>
        </ng-template>
    </p-table>

    <!-- Descripciones -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <!-- Descripción Probabilidad -->
        <div>
            <div class="bg-emerald-900 text-white font-semibold px-4 py-2 rounded-t">Descripción Probabilidad de Ocurrencia</div>
            <table class="w-full border border-gray-300 dark:border-gray-600 text-sm">
                @for (d of descripcionProbabilidades; track d) {
                    <tr>
                        <td class="border border-gray-300 dark:border-gray-600 px-3 py-2 font-bold text-center w-14">
                            {{ d.valor }}
                        </td>
                        <td class="border border-gray-300 dark:border-gray-600 px-3 py-2">
                            <div class="font-semibold text-gray-800 dark:text-gray-200">{{ d.etiqueta }}</div>
                            <div class="text-gray-600 dark:text-gray-400 text-xs">{{ d.descripcion }}</div>
                        </td>
                    </tr>
                }
            </table>
        </div>

        <!-- Riesgo Potencial -->
        <div>
            <div class="bg-emerald-900 text-white font-semibold px-4 py-2 rounded-t">Riesgo Potencial</div>
            <table class="w-full border border-gray-300 dark:border-gray-600 text-sm">
                @for (r of descripcionRiesgo; track r) {
                    <tr>
                        <td class="border border-gray-300 dark:border-gray-600 px-3 py-2 font-bold text-center w-14">
                            {{ r.valor }}
                        </td>
                        <td class="border border-gray-300 px-3 py-2">
                            <div class="font-semibold">
                                <span [ngClass]="r.color" class="px-2 rounded text-white dark:text-gray-100">{{ r.titulo }}</span>
                            </div>
                            <div class="text-gray-600 dark:text-gray-400 text-xs">{{ r.descripcion }}</div>
                        </td>
                    </tr>
                }
            </table>
        </div>
    </div>

    <!-- Acciones -->
    <div class="w-full flex justify-center gap-4 mt-10">
        <!-- Cancelar removido -->
    <p-button label="Aceptar" icon="pi pi-check" class="font-semibold" [disabled]="!esValido()" (onClick)="guardar()"> </p-button>
    </div>
</div>
